import React from 'react';
import { CnLayoutPage as UICnLayoutPage } from "../../components/cn-layout";
var CnLayoutPage = function CnLayoutPage(props) {
  var _ref = props || {},
    children = _ref.children;
  return /*#__PURE__*/React.createElement(UICnLayoutPage, null, children);
};
CnLayoutPage.displayName = 'CnLayoutPage';
export default CnLayoutPage;
export { CnLayoutPage };